// import _ from 'lodash';

const analyticsTypes = {
  ETAILER_LIST_VIEW: 'etailer__listView',
};


const analyticsActions = [{
  type: analyticsTypes.ETAILER_LIST_VIEW
}];

export {
  analyticsTypes,
  analyticsActions
};
